import { Component } from "react";
import Select from "react-select";

class SearchableSelect extends Component {
    render() {
        const { options, value, onChange, placeholder, isInvalid, isDisabled, name } = this.props;

        const selected = options.find((o) => o.value === value) || null;

        return (
            <Select
                classNamePrefix="cSelect"
                className={isInvalid ? "cSelect--invalid" : ""}
                options={options}
                value={selected}
                onChange={(opt) => onChange({ target: { name, value: opt ? opt.value : "" } })}
                placeholder={placeholder || "انتخاب کنید"}
                isSearchable
                isClearable
                isDisabled={isDisabled}
                noOptionsMessage={() => "موردی یافت نشد"}
                loadingMessage={() => "در حال بارگذاری..."}
                menuPlacement="auto"
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={{
                    control: (base, state) => ({
                        ...base,
                        minHeight: 44,
                        borderRadius: 10,
                        borderColor: isInvalid ? "#dc3545" : state.isFocused ? "#457b9d" : "#dfe5ea",
                        backgroundColor: isInvalid ? "#fff5f5" : state.isFocused ? "#fff" : "#f4f6f8",
                        boxShadow: isInvalid
                            ? "0 0 0 3px rgba(220, 53, 69, 0.15)"
                            : "none",
                        transition: "all 0.2s ease",
                    }),
                    valueContainer: (base) => ({ ...base, padding: "2px 12px" }),
                    placeholder: (base) => ({ ...base, color: "#9aa6b2", fontSize: 13 }),
                    singleValue: (base) => ({ ...base, color: "#212529", fontSize: 14 }),
                    input: (base) => ({
                        ...base,
                        fontSize: 14,
                        color: "#212529",
                        boxShadow: "none",
                        outline: "none",
                        border: "none",
                        background: "transparent",
                        "&:focus": {
                            boxShadow: "none",
                            outline: "none",
                            border: "none",
                        },
                    }),
                    menu: (base) => ({
                        ...base,
                        borderRadius: 10,
                        overflow: "hidden",
                        zIndex: 100000,
                        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
                    }),
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 100000,
                    }),
                    menuList: (base) => ({ ...base, maxHeight: 240 }),
                    option: (base, state) => ({
                        ...base,
                        fontSize: 13,
                        padding: "9px 12px",
                        // فقط بر اساس isFocused رنگ بده (نه isSelected)
                        backgroundColor: state.isFocused
                            ? "rgba(69, 123, 157, 0.1)"
                            : "#fff",
                        color: "#212529",
                        cursor: "pointer",
                        // حذف هر استایل :active که ممکنه تداخل کنه
                        "&:active": {
                            backgroundColor: "rgba(69, 123, 157, 0.1)",
                        },
                    }),
                    indicatorSeparator: () => ({ display: "none" }),
                    dropdownIndicator: (base) => ({ ...base, color: "#5c5c5c" }),
                    clearIndicator: (base) => ({ ...base, color: "#5c5c5c" }),
                }}
                theme={(theme) => ({
                    ...theme,
                    colors: {
                        ...theme.colors,
                        primary: "#457b9d",
                        primary25: "rgba(69, 123, 157, 0.1)",
                    },
                })}
            />
        );
    }
}

export default SearchableSelect;